import { useCallback, useSyncExternalStore } from 'react';
import type { MessengerThread } from '@/api/client';
import {
  getMessengerThreadByPeerId,
  subscribeMessengerThreadByPeerId,
} from '@/components/Messenger/cache/messengerThreadsStore';

export function useMessengerThreadByPeerId(peerId: string): MessengerThread | undefined {
  return useSyncExternalStore(
    useCallback((onChange) => subscribeMessengerThreadByPeerId(peerId, onChange), [peerId]),
    () => getMessengerThreadByPeerId(peerId),
    () => undefined
  );
}
